function drawHallScheme()
{
    const placeWidth = 15;
    const placeHeight = 15;

    var hallSchema = d3.select('#hallSchema');

    const canvasWidth = $('.tickets-choose-container').width() + 600;
    let canvasHeight = php.minMaxCoordsInHall['maxTop'] + 400;
    canvasHeight = canvasHeight === null || canvasHeight > 530 ? 530 : canvasHeight;

    /*if (2 > (canvasWidth / canvasHeight)) {
        canvasHeight -= canvasWidth / 3;
    }*/

    const sceneHeight = 50;

    let ticketsValues = new Map();
    Object.entries(php.hallPlacesMap).forEach(([key, value])=>{
        ticketsValues.set(
            value.Price,
            php.schemaHallList[value.cod_hs].BackColor
        )
    });

    let ticketValuesArray = [...ticketsValues].sort((a, b) => { return a[0] - b[0]; });

    ticketValuesArray.forEach((value) => {
        let currency = '';

        if (typeof php.currency !== 'undefined') {
            currency = php.currency;
        }

        if (parseInt(value[0]) > 0) {
            let priceHtml = '<span class="priceVariant"><span style="background:#' + value[1] + ';"></span>' + app.formatPriceRoubles(parseInt(value[0]), currency) + '</span>';
            $('#hallPricesVariants').append(priceHtml);
        }
    });

    $('#hallPricesVariants > span').on('click', function() {
        let allRects = $('.placeSeat > rect');

        if ($(this).hasClass('active')) {
            allRects.css('opacity', '1');
            $(this).removeClass('active');
            $(this).css('backgroundColor', 'white');
        } else {
            let color = $(this).find('span').css('backgroundColor');
            allRects.css('opacity', '1');
            $('#hallPricesVariants > span').css('backgroundColor', 'white');

            allRects.each((index, value) => {
                if ($(value).css('fill') !== color) {
                    $(value).css('opacity', '0.2');
                }
            });
            $('#hallPricesVariants > span').removeClass('active');
            $(this).addClass('active');
            $(this).css('backgroundColor', color);
        }
    });

    hallSchema.attr('width', canvasWidth).attr('height', canvasHeight - 20);

    if ('top' === php.sceneOrientation) {
        var viewBoxY = -50;
    } else {
        var viewBoxY = -30;
    }

    hallSchema
        .attr("viewBox", "0 " + viewBoxY + " " + (php.minMaxCoordsInHall['maxLeft'] + 90) + " " + (php.minMaxCoordsInHall['maxTop'] + sceneHeight + 90))
        .attr('currentScale', 1)
        .attr("preserveAspectRatio", "xMidYMid");

    width  = +hallSchema.attr("width");
    height = +hallSchema.attr("height");

    zoom = d3.zoom()
        .scaleExtent([1, 5])
        .translateExtent([[-50, -50], [width + (width / 1.2), height + (height / 1.2)]])
        .on("zoom", zoomed);

    var mainBlock = hallSchema.append('g');

    mainBlock.attr('id', 'scallable');

    for (var mixedRowIndex in php.schemaGroupedByRow) {
        var rowPlaces = php.schemaGroupedByRow[mixedRowIndex];

        var rowIndex = mixedRowIndex.split('_')[0];

        var firstPlaceInRow = rowPlaces[0];

        var rowText = mainBlock.append('text')
            .attr('width', placeWidth).attr('height', placeHeight)
            .attr('class', 'rowIndex');
            //.text(rowIndex);

        var rowTextWidth = rowText.node().getBBox().width;

        rowText.attr('x', fixX(firstPlaceInRow.CX - rowTextWidth, -1))
            .attr('y', firstPlaceInRow.CY + 12);

        var rowText = mainBlock.append('text')
            .attr('width', placeWidth).attr('height', placeHeight)
            .attr('class', 'rowIndex');
            //.text(rowIndex);

        var lastPlaceInRow = rowPlaces[rowPlaces.length - 1];

        rowText.attr('x', fixX(lastPlaceInRow.CX + placeWidth + 2, -1, 2))
            .attr('y', lastPlaceInRow.CY + 12);

        for (var i in rowPlaces) {
            hallPlace = php.schemaHallList[rowPlaces[i].cod_hs];

            i = parseInt(i);

            if (undefined !== rowPlaces[i + 1]) {
                var nextHallPlace = php.schemaHallList[rowPlaces[i + 1].cod_hs];
                var coordDiff = nextHallPlace.CX - hallPlace.CX;
                if (20 < coordDiff) {
                    var rowTextCoordX = fixX(hallPlace.CX + 18);

                    var rowText = mainBlock.append('text')
                        .attr('width', placeWidth).attr('height', placeHeight)
                        .attr('class', 'rowIndex')
                        .attr('x', rowTextCoordX)
                        .attr('y', hallPlace.CY + 12);
                        //.text(rowIndex);

                    if (40 < coordDiff) {
                        var rowText = mainBlock.append('text')
                            .attr('width', placeWidth).attr('height', placeHeight)
                            .attr('class', 'rowIndex')
                            .attr('y', hallPlace.CY + 12);
                            //.text(rowIndex);

                        var rowTextWidth  = rowText.node().getBBox().width;
                        var rowTextCoordX = fixX(nextHallPlace.CX - rowTextWidth, -1, -1);

                        rowText.attr('x', rowTextCoordX);
                    }
                }
            }

            var placeIsReserved = php.hallPlacesMap[hallPlace.cod_hs].reserved;

            var placeBlock = mainBlock.append('g');

            var place = placeBlock.append('rect')
                .attr('x', hallPlace.CX)
                .attr('y', hallPlace.CY)
                .attr('ry', 10)
                .attr('ry', 10)
                .attr('width', placeWidth).attr('height', placeHeight);

            var currentPlace = php.hallPlacesMap[hallPlace.cod_hs];

            placeBlock.attr('class', 'placeSeat');

            var seatText = placeBlock.append('text');

            var textSeatWidth  = seatText.node().getBBox().width;
            var textSeatHeight = seatText.node().getBBox().height;

            seatText.attr('x', fixX(hallPlace.CX + ((placeWidth - textSeatWidth) / 2) + 8, -4))
                .attr('y', hallPlace.CY + 12);

            place
                .attr('class', 'hallPlace')
                .attr('stroke-width', 0);

            var node = $(place.node());

            node.data('id', hallPlace.cod_hs);
            node.data('checked', false);
            node.data('disabled', placeIsReserved);

            if (!placeIsReserved) {
                // remove (if) after end of event 6276
                if ('6276' == php.lectureDetails.lectureId && hallPlace.BackColor == '99CCCC') {
                    hallPlace.BackColor = '99cc66'
                }

                place.style('fill', '#' + hallPlace.BackColor);
            } else {
                place.style('fill', '#808080');
                place.style('width', '9px');
                place.style('height', '9px');
                place
                .attr('x', hallPlace.CX+3)
                .attr('y', hallPlace.CY+3)

            }

            if (isSelectedPlace(hallPlace.Row, hallPlace.Seat)) {
                place.style('fill', '#e50341');
                node.data('checked', true);
            }

            if (!mobileAndTabletcheck()) {
                placeBlock.on('mouseover', function()
                {
                    $('.placeInfo').remove();

                    let currency = '';

                    if (typeof php.currency !== 'undefined') {
                        currency = php.currency;
                    }

                    const sender = $(this).find('rect');
                    const d3Sender = d3.select(this).select('rect');

                    const currentPlace = php.hallPlacesMap[sender.data('id')];
                    const hallPlace = php.schemaHallList[currentPlace.cod_hs];
                    if (sender.data('disabled') || sender.data('checked')) {
                        return;
                    }

                    var html = "<span>" + app.formatPriceRoubles(parseInt(currentPlace.Price), currency) + "</span><br/>";
                    html += "<span>" + currentPlace.name_sec + "</span><br/>";
                    html += "<span>" + currentPlace.row + " ряд, " + currentPlace.seat + " место</span>";

                    $('.tickets-choose-container > div').after($('<div>').addClass('placeInfo'));

                    setChoosedTicket(hallPlace, sender, d3Sender, 3);

                    $(this).css('filter', 'drop-shadow(1px 1px 4px rgba(0, 0, 0, .7))');

                    $('.placeInfo').html(html).css({
                        left: sender.offset().left - $('.tickets-choose-container').offset().left - $('.placeInfo').width()/2 - sender.width()/2,
                        top : sender.offset().top - $('.tickets-choose-container').offset().top - $('.placeInfo').height() - 30,
                    });
                });

                placeBlock.on('mouseout', function()
                {
                    var sender = $(this).find('rect');
                    var d3Sender = d3.select(this).select('rect');
                    const currentPlace = php.hallPlacesMap[sender.data('id')];
                    const hallPlace = php.schemaHallList[currentPlace.cod_hs];

                    if (sender.data('disabled') || sender.data('checked')) {
                        return;
                    }
                    unsetChoosedTicket(hallPlace, sender, d3Sender);
                    $(this).css('filter', 'unset');
                    $('.placeInfo').remove();
                });
            }

            placeBlock.on('click', function()
            {
                $('.placeInfo').remove();

                var sender   = $(this).find('rect');
                var d3Sender = d3.select(this).select('rect');

                if (sender.data('disabled')) {
                    return;
                }

                let $ticketsCountSelect = $('.offline-ticket__form').find('.tickets-count-select-wrap select');
                let currentPlace = php.hallPlacesMap[sender.data('id')];
                let html = "<span>" +  + "</span><br/>";

                let currency = '';

                if (typeof php.currency !== 'undefined') {
                    currency = php.currency;
                }

                html += "<span>Ряд: " + currentPlace.row + ", место: " + currentPlace.seat + "</span><br/>";
                html += "<span>" +  + " руб.</span>";

                if (false === sender.data('checked')) {
                    sender.data('checked', true);

                    if (php.maxTicketsInOrder >= getSelectedTicketsCount()) {

                        if (app.isMobile()) {
                            $('.mobile-chosen-tickets').show();
                        }

                        let htmlToAdd = '<span class="choosed-ticket-span" data-id="' + sender.data('id') + '">';
                        htmlToAdd += '<span>' + app.formatPriceRoubles(parseInt(currentPlace.Price), currency)  + '</span><br>';
                        htmlToAdd += currentPlace.name_sec + '<br>';
                        htmlToAdd += '<span>' + currentPlace.row + ' ряд, ' + currentPlace.seat + ' место </span><br>'
                        htmlToAdd += '<span class="remove-chosen-ticket">&times;</span></span>'
                        $('.chosen-tickets-container').append(htmlToAdd);

                        $('.remove-chosen-ticket').on('click', function () {
                            let dataId = $(this).parent().attr('data-id');
                            $('.chosen-tickets-container span[data-id="' + dataId + '"]').remove();
                            let gPlaceSeats = $('g.placeSeat');
                            gPlaceSeats.each((index, value) => {
                                let obj = $(value).find('rect');

                               if (obj.data('id') === dataId) {
                                   obj.data('checked', false);
                                   let d3Sender = d3.select(value).select('rect');
                                   let currentPlace = php.hallPlacesMap[obj.data('id')];
                                   let hallPlace = php.schemaHallList[currentPlace.cod_hs];
                                   $(value).css('filter', 'unset');

                                   unsetChoosedTicket(hallPlace, obj, d3Sender);

                                   $ticketsCountSelect.val(getSelectedTicketsCount() ?? 1).trigger('change');
                                   $('.tickets-choose-modal-overflow').fadeOut();
                                   if (getSelectedTicketsCount() === 0){
                                       $('.offline-ticket__form .priceMatrixWrap').hide();
                                       $('.offline-ticket__form .pricesStrAllSumWrapper').hide();
                                       //$('.offline-ticket__form .event-info-aside__buy-ticket___promo-code').hide();
                                   }
                               }
                            });
                        });
                    } else {
                        $('.tickets-choose-modal-overflow').css('display', 'flex');
                        $('.tickets-choose-modal-overflow span:first-child').text('За один заказ можно купить только '+ php.maxTicketsInOrder + ' билетов');
                        $('.ticket-choose-modal-overflow-close').on('click', function() {
                            $(this).parent().hide();
                        })
                    }
                } else {
                    sender.data('checked', false);
                    $(sender).data('checked', false);
                    $('.tickets-choose-modal-overflow').fadeOut();
                    $('.chosen-tickets-container span[data-id="' + sender.data('id') + '"]').remove();
                }

                if (php.maxTicketsInOrder < getSelectedTicketsCount()) {
                    sender.data('checked', false);
                    $(sender).data('checked', false);
                    return;
                }
                let hallPlace = php.schemaHallList[currentPlace.cod_hs];

                if (false !== sender.data('checked')) {
                    setChoosedTicket(hallPlace, sender, d3Sender, 6);
                    $('.errors-container span:first-of-type').remove();
                } else {
                    unsetChoosedTicket(hallPlace, sender, d3Sender);
                }

                //recalculateSelectedTicketPrice();

                var ticketsAmount = getSelectedTicketsCount();
                if (!ticketsAmount) {
                    ticketsAmount = 1;
                }

                var currSelectedTicketsCount = $ticketsCountSelect.val();
                var isGiftTickets = false;

                $('.event-info-aside__buy-ticket__members-wrapper').remove();

                if (ticketsAmount > currSelectedTicketsCount) {
                    $ticketsCountSelect.val(ticketsAmount).trigger('change');
                } else if (ticketsAmount < currSelectedTicketsCount && !isGiftTickets) {
                    $ticketsCountSelect.val(ticketsAmount).trigger('change');
                } else {
                    $ticketsCountSelect.val(currSelectedTicketsCount).trigger('change');
                }

                if (getSelectedTicketsCount() === 0){
                    $('.offline-ticket__form .priceMatrixWrap').hide();
                    $('.offline-ticket__form .pricesStrAllSumWrapper').hide();
                } else {
                    $('.offline-ticket__form .priceMatrixWrap').show();
                    $('.offline-ticket__form .pricesStrAllSumWrapper').show();
                }
                //toggleGiveTicketToFriendCheckbox();

                updateFriendPlaces();
            });
        }

    }
    if ('6155' == php.lectureDetails.lectureId) {
        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 20)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 32)
            .attr('y', 25);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 80)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 32)
            .attr('y', 85);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 145)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 32)
            .attr('y', 150);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 208)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 32)
            .attr('y', 213);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 270)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(5)
            .attr('x', 32)
            .attr('y', 275);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 335)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(6)
            .attr('x', 32)
            .attr('y', 341);

        var place = placeBlock.append('circle')
            .attr('cx', 38)
            .attr('cy', 402)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(7)
            .attr('x', 34)
            .attr('y', 406);

        var place = placeBlock.append('circle')
            .attr('cx', 135)
            .attr('cy', 480)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(8)
            .attr('x', 130)
            .attr('y', 485);

        var place = placeBlock.append('circle')
            .attr('cx', 228)
            .attr('cy', 480)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(9)
            .attr('x', 223)
            .attr('y', 485);

        var place = placeBlock.append('circle')
            .attr('cx', 315)
            .attr('cy', 480)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(10)
            .attr('x', 306)
            .attr('y', 485);

        var place = placeBlock.append('circle')
            .attr('cx', 410)
            .attr('cy', 480)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(11)
            .attr('x', 402)
            .attr('y', 485);

        var place = placeBlock.append('circle')
            .attr('cx', 508)
            .attr('cy', 405)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(12)
            .attr('x', 500)
            .attr('y', 410);

        var place = placeBlock.append('circle')
            .attr('cx', 508)
            .attr('cy', 335)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(13)
            .attr('x', 500)
            .attr('y', 340);

        var place = placeBlock.append('circle')
            .attr('cx', 505)
            .attr('cy', 271)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(14)
            .attr('x', 497)
            .attr('y', 275);

        var place = placeBlock.append('circle')
            .attr('cx', 505)
            .attr('cy', 206)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(15)
            .attr('x', 497)
            .attr('y', 210);

        var place = placeBlock.append('circle')
            .attr('cx', 505)
            .attr('cy', 145)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(16)
            .attr('x', 497)
            .attr('y', 150);

        var place = placeBlock.append('circle')
            .attr('cx', 503)
            .attr('cy', 80)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(17)
            .attr('x', 496)
            .attr('y', 86);

        var place = placeBlock.append('circle')
            .attr('cx', 500)
            .attr('cy', 20)
            .attr('r', 18)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(18)
            .attr('x', 492)
            .attr('y', 25);

        var place = placeBlock.append('line')
            .attr('x1', 100)
            .attr('y1', 0)
            .attr('x2', 100)
            .attr('y2', 430)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        var place = placeBlock.append('line')
            .attr('x1', 100)
            .attr('y1', 430)
            .attr('x2', 450)
            .attr('y2', 430)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        var place = placeBlock.append('line')
            .attr('x1', 450)
            .attr('y1', 430)
            .attr('x2', 450)
            .attr('y2', 0)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        mainBlock.append('text')
            .text('БАЛКОН ЛЕВАЯ СТОРОНА')
            .attr('x', -330)
            .attr('y', -30)
            .attr('transform', 'rotate(270)');

        mainBlock.append('text')
            .text('БАЛКОН ПРАВАЯ СТОРОНА')
            .attr('x', 130)
            .attr('y', -570)
            .attr('transform', 'rotate(90)');

        mainBlock.append('text')
            .text('БАЛКОН СЕРЕДИНА')
            .attr('x', 200)
            .attr('y', 550);
    }

    if ('CatHouse Concert Hall' == php.lectureDetails.eventPlace) {
        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('circle')
            .attr('cx', 777)
            .attr('cy', 345)
            .attr('r', 15)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 773)
            .attr('y', 350);

        var place = placeBlock.append('circle')
            .attr('cx', 831)
            .attr('cy', 280)
            .attr('r', 15)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 827)
            .attr('y', 285);

        var place = placeBlock.append('circle')
            .attr('cx', 165)
            .attr('cy', 35)
            .attr('r', 15)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(7)
            .attr('x', 162)
            .attr('y', 41);

        var place = placeBlock.append('circle')
            .attr('cx', 70)
            .attr('cy', 110)
            .attr('r', 15)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(8)
            .attr('x', 65)
            .attr('y', 115);

        var place = placeBlock.append('circle')
            .attr('cx', 45)
            .attr('cy', 287)
            .attr('r', 15)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(9)
            .attr('x', 40)
            .attr('y', 292);

        var place = placeBlock.append('circle')
            .attr('cx', 100)
            .attr('cy', 347)
            .attr('r', 15)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(10)
            .attr('x', 92)
            .attr('y', 352);

        var place = mainBlock.append('rect')
            .attr('x', 0)
            .attr('y', 245)
            .attr('width', 150)
            .attr('height', 19)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white')
            .attr('transform', 'rotate(46,100,347)');
        mainBlock.append('text')
            .text(24)
            .attr('x', 70)
            .attr('y', 257.5)
            .attr('dy', '.13em')
            .attr('transform', 'rotate(46,100,347)');

        var place = mainBlock.append('rect')
            .attr('x', -440)
            .attr('y', -105)
            .attr('width', 150)
            .attr('height', 19)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white')
            .attr('transform', 'rotate(128,100,347)');
        mainBlock.append('text')
            .text(25)
            .attr('x', 600)
            .attr('y', 737)
            .attr('transform', 'rotate(-46,110,345)');
    }

    if ('Legendos klubas' == php.lectureDetails.eventPlace && '6155' != php.lectureDetails.lectureId) {
        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 36)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 33)
            .attr('y', 41);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 117)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 32)
            .attr('y', 122);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 197)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 32)
            .attr('y', 203);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 275)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 32)
            .attr('y', 280);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 355)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(5)
            .attr('x', 32)
            .attr('y', 360);

        var place = placeBlock.append('circle')
            .attr('cx', 36)
            .attr('cy', 436)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(6)
            .attr('x', 32)
            .attr('y', 442);

        var place = placeBlock.append('circle')
            .attr('cx', 38)
            .attr('cy', 517)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(7)
            .attr('x', 34)
            .attr('y', 522);

        var place = placeBlock.append('circle')
            .attr('cx', 242)
            .attr('cy', 568)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(8)
            .attr('x', 237)
            .attr('y', 573);

        var place = placeBlock.append('circle')
            .attr('cx', 326)
            .attr('cy', 568)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(9)
            .attr('x', 322)
            .attr('y', 573);

        var place = placeBlock.append('circle')
            .attr('cx', 408)
            .attr('cy', 568)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(10)
            .attr('x', 400)
            .attr('y', 573);

        var place = placeBlock.append('circle')
            .attr('cx', 489)
            .attr('cy', 568)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(11)
            .attr('x', 481)
            .attr('y', 573);

        var place = placeBlock.append('circle')
            .attr('cx', 700)
            .attr('cy', 527)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(12)
            .attr('x', 692)
            .attr('y', 532);

        var place = placeBlock.append('circle')
            .attr('cx', 700)
            .attr('cy', 447)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(13)
            .attr('x', 692)
            .attr('y', 453);

        var place = placeBlock.append('circle')
            .attr('cx', 700)
            .attr('cy', 362)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(14)
            .attr('x', 692)
            .attr('y', 367);

        var place = placeBlock.append('circle')
            .attr('cx', 700)
            .attr('cy', 278)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(15)
            .attr('x', 692)
            .attr('y', 284);

        var place = placeBlock.append('circle')
            .attr('cx', 700)
            .attr('cy', 198)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(16)
            .attr('x', 692)
            .attr('y', 204);

        var place = placeBlock.append('circle')
            .attr('cx', 700)
            .attr('cy', 118)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(17)
            .attr('x', 692)
            .attr('y', 124);

        var place = placeBlock.append('circle')
            .attr('cx', 700)
            .attr('cy', 38)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(18)
            .attr('x', 692)
            .attr('y', 44);

        var place = placeBlock.append('line')
            .attr('x1', 70)
            .attr('y1', 0)
            .attr('x2', 70)
            .attr('y2', 544)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        var place = placeBlock.append('line')
            .attr('x1', 70)
            .attr('y1', 544)
            .attr('x2', 670)
            .attr('y2', 544)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        var place = placeBlock.append('line')
            .attr('x1', 670)
            .attr('y1', 544)
            .attr('x2', 670)
            .attr('y2', 0)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        mainBlock.append('text')
            .text('БАЛКОН ЛЕВАЯ СТОРОНА')
            .attr('x', -330)
            .attr('y', -30)
            .attr('transform', 'rotate(270)');

        mainBlock.append('text')
            .text('БАЛКОН ПРАВАЯ СТОРОНА')
            .attr('x', 130)
            .attr('y', -770)
            .attr('transform', 'rotate(90)');

        mainBlock.append('text')
            .text('БАЛКОН СЕРЕДИНА')
            .attr('x', 290)
            .attr('y', 625);

        var place = placeBlock.append('circle')
            .attr('cx', 170)
            .attr('cy', 48)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 166)
            .attr('y', 53);

        var place = placeBlock.append('circle')
            .attr('cx', 171)
            .attr('cy', 132)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 166)
            .attr('y', 137);

        var place = placeBlock.append('circle')
            .attr('cx', 171)
            .attr('cy', 215)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 166)
            .attr('y', 220);

        var place = placeBlock.append('circle')
            .attr('cx', 171)
            .attr('cy', 300)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 166)
            .attr('y', 305);

        var place = placeBlock.append('circle')
            .attr('cx', 171)
            .attr('cy', 384)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(5)
            .attr('x', 166)
            .attr('y', 390);

        var place = placeBlock.append('circle')
            .attr('cx', 171)
            .attr('cy', 464)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(6)
            .attr('x', 166)
            .attr('y', 470);

        var place = placeBlock.append('circle')
            .attr('cx', 555)
            .attr('cy', 465)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(7)
            .attr('x', 552)
            .attr('y', 470);

        var place = placeBlock.append('circle')
            .attr('cx', 553)
            .attr('cy', 383)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(8)
            .attr('x', 548)
            .attr('y', 388);

        var place = placeBlock.append('circle')
            .attr('cx', 553)
            .attr('cy', 300)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(9)
            .attr('x', 548)
            .attr('y', 305);

        var place = placeBlock.append('circle')
            .attr('cx', 553)
            .attr('cy', 215)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(10)
            .attr('x', 544)
            .attr('y', 220);

        var place = placeBlock.append('circle')
            .attr('cx', 553)
            .attr('cy', 132)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(11)
            .attr('x', 545)
            .attr('y', 138);

        var place = placeBlock.append('circle')
            .attr('cx', 553)
            .attr('cy', 49)
            .attr('r', 17)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(12)
            .attr('x', 544)
            .attr('y', 54);
    }

    // hall with tables
    if ('Клуб «Высоцкий»'.toUpperCase() == (php.lectureDetails.eventPlace).toUpperCase()) {
        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 30)
            .attr('y', 107)
            .attr('width', 75)
            .attr('height', 45)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(6)
            .attr('x', 65)
            .attr('y', 133)

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 25)
            .attr('y', 230)
            .attr('width', 45)
            .attr('height', 75)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(5)
            .attr('x', 44)
            .attr('y', 270)

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('ellipse')
            .attr('cx', 49)
            .attr('cy', 429)
            .attr('rx', 25)
            .attr('ry', 40)
            .attr('width', 45)
            .attr('height', 75)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 44)
            .attr('y', 435)

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 25)
            .attr('y', 542)
            .attr('width', 45)
            .attr('height', 45)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 44)
            .attr('y', 570);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 25)
            .attr('y', 665)
            .attr('width', 45)
            .attr('height', 45)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 44)
            .attr('y', 690);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 25)
            .attr('y', 783)
            .attr('width', 45)
            .attr('height', 45)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 44)
            .attr('y', 810);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 140)
            .attr('y', -147)
            .attr('width', 45)
            .attr('height', 45)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('transform', 'rotate(45)')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(7)
            .attr('x', 200)
            .attr('y', 33);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('circle')
            .attr('cx', 208)
            .attr('cy', 345)
            .attr('r', 25)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(14)
            .attr('x', 200)
            .attr('y', 350);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('circle')
            .attr('cx', 208)
            .attr('cy', 505)
            .attr('r', 25)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(15)
            .attr('x', 200)
            .attr('y', 509);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('circle')
            .attr('cx', 208)
            .attr('cy', 625)
            .attr('r', 25)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(16)
            .attr('x', 200)
            .attr('y', 630);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('ellipse')
            .attr('cx', 348)
            .attr('cy', 105)
            .attr('rx', 25)
            .attr('ry', 40)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(8)
            .attr('x', 345)
            .attr('y', 110);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('ellipse')
            .attr('cx', 348)
            .attr('cy', 245)
            .attr('rx', 40)
            .attr('ry', 25)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(9)
            .attr('x', 345)
            .attr('y', 250);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('ellipse')
            .attr('cx', 348)
            .attr('cy', 385)
            .attr('rx', 25)
            .attr('ry', 40)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(10)
            .attr('x', 340)
            .attr('y', 390);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 327)
            .attr('y', 504)
            .attr('width', 45)
            .attr('height', 45)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(11)
            .attr('x', 342)
            .attr('y', 532);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('ellipse')
            .attr('cx', 348)
            .attr('cy', 667)
            .attr('rx', 25)
            .attr('ry', 40)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(12)
            .attr('x', 342)
            .attr('y', 675);

        var placeBlock = mainBlock.append('g');
        var place = placeBlock.append('rect')
            .attr('x', 794)
            .attr('y', 303)
            .attr('width', 45)
            .attr('height', 45)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('transform', 'rotate(45)')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(13)
            .attr('x', 340)
            .attr('y', 812);
    }

    if ('Theater im Delphi' === php.lectureDetails.eventPlace) {
        mainBlock.append('text')
            .text('БАЛКОН')
            .attr('x', 300)
            .attr('y', -15);

        placeBlock.append('line')
            .attr('x1', 89)
            .attr('y1', 0)
            .attr('x2', 89)
            .attr('y2', 210)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        placeBlock.append('line')
            .attr('x1', 89)
            .attr('y1', 210)
            .attr('x2', 509)
            .attr('y2', 210)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        placeBlock.append('line')
            .attr('x1', 509)
            .attr('y1', 210)
            .attr('x2', 509)
            .attr('y2', 0)
            .style('stroke', 'black')
            .style('stroke-width', 2);

        placeBlock = mainBlock.append('g');

        placeBlock.append('circle')
            .attr('cx', 10)
            .attr('cy', 354)
            .attr('r', 20)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 5)
            .attr('y', 359);

        placeBlock.append('circle')
            .attr('cx', 10)
            .attr('cy', 543)
            .attr('r', 19)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(6)
            .attr('x', 5)
            .attr('y', 548);

        placeBlock.append('circle')
            .attr('cx', 10)
            .attr('cy', 715)
            .attr('r', 19)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(6)
            .attr('x', 5)
            .attr('y', 720);

        placeBlock.append('circle')
            .attr('cx', 615)
            .attr('cy', 354)
            .attr('r', 19)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 610)
            .attr('y', 360);

        placeBlock.append('circle')
            .attr('cx', 617)
            .attr('cy', 543)
            .attr('r', 19)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 612)
            .attr('y', 548);

        placeBlock.append('circle')
            .attr('cx', 617)
            .attr('cy', 715)
            .attr('r', 19)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 612)
            .attr('y', 720);

        placeBlock.append('circle')
            .attr('cx', 190)
            .attr('cy', 460)
            .attr('r', 26)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 185)
            .attr('y', 464);

        placeBlock.append('circle')
            .attr('cx', 443)
            .attr('cy', 460)
            .attr('r', 26)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 438)
            .attr('y', 464);

        placeBlock.append('rect')
            .attr('x', 295)
            .attr('y', 440)
            .attr('width', 40)
            .attr('height', 40)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 310)
            .attr('y', 465);

        placeBlock.append('rect')
            .attr('x', 115)
            .attr('y', 556)
            .attr('width', 35)
            .attr('height', 59)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(5)
            .attr('x', 127)
            .attr('y', 590);

        placeBlock.append('rect')
            .attr('x', 235)
            .attr('y', 556)
            .attr('width', 35)
            .attr('height', 59)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 248)
            .attr('y', 590);

        placeBlock.append('rect')
            .attr('x', 358)
            .attr('y', 556)
            .attr('width', 35)
            .attr('height', 59)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 370)
            .attr('y', 590);

        placeBlock.append('rect')
            .attr('x', 477)
            .attr('y', 556)
            .attr('width', 35)
            .attr('height', 59)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 489)
            .attr('y', 590);

        placeBlock.append('rect')
            .attr('x', 115)
            .attr('y', 669)
            .attr('width', 35)
            .attr('height', 50)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(5)
            .attr('x', 127)
            .attr('y', 699);

        placeBlock.append('rect')
            .attr('x', 115)
            .attr('y', 789)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 127)
            .attr('y', 812);

        placeBlock.append('rect')
            .attr('x', 115)
            .attr('y', 882)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 127)
            .attr('y', 906);

        placeBlock.append('rect')
            .attr('x', 235)
            .attr('y', 671)
            .attr('width', 35)
            .attr('height', 50)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(4)
            .attr('x', 248)
            .attr('y', 699);

        placeBlock.append('rect')
            .attr('x', 358)
            .attr('y', 671)
            .attr('width', 35)
            .attr('height', 50)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 370)
            .attr('y', 699);

        placeBlock.append('rect')
            .attr('x', 480)
            .attr('y', 669)
            .attr('width', 35)
            .attr('height', 50)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 493)
            .attr('y', 699);

        placeBlock.append('rect')
            .attr('x', 237)
            .attr('y', 789)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 250)
            .attr('y', 812);

        placeBlock.append('rect')
            .attr('x', 358)
            .attr('y', 789)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 370)
            .attr('y', 812);

        placeBlock.append('rect')
            .attr('x', 480)
            .attr('y', 789)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 495)
            .attr('y', 812);

        placeBlock.append('rect')
            .attr('x', 240)
            .attr('y', 882)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(3)
            .attr('x', 252)
            .attr('y', 906);

        placeBlock.append('rect')
            .attr('x', 357)
            .attr('y', 882)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(2)
            .attr('x', 370)
            .attr('y', 906);

        placeBlock.append('rect')
            .attr('x', 481)
            .attr('y', 882)
            .attr('width', 35)
            .attr('height', 35)
            .attr('stroke', 'black')
            .attr('stroke-width', '1')
            .attr('fill', 'white');
        mainBlock.append('text')
            .text(1)
            .attr('x', 495)
            .attr('y', 906);
    }

    let sceneText = mainBlock.append('text').attr('class', 'scene');

    if (php.lectureDetails.lectureId == 3076) {
        sceneText.attr('x', php.minMaxCoordsInHall['maxLeft'] / 2 - textSeatWidth / 2 - 5);
    } else {
        sceneText.text(php.lectureDetails.lectureId === 7679 ? 'ЭКРАН' : 'СЦЕНА');

        let textDimensions = sceneText.node().getBBox();
        let sceneX = php.minMaxCoordsInHall['maxLeft'] / 2 - textDimensions.width / 2 - 5;
        let sceneY = php.sceneOrientation === 'top' ? -15 : php.minMaxCoordsInHall['maxTop'] + textDimensions.height + 50;

        sceneText.attr('x', sceneX).attr('y', sceneY);
    }

    hallSchema.call(zoom);

    function zoomed()
    {
        mainBlock.attr("transform", d3.event.transform);
    }
    $('#scaleUp').click(function()
    {
        var g = d3.select('#scallable');
        zoom.scaleBy(g, 1.1);
    });

    $('#scaleDown').click(function()
    {
        var g = d3.select('#scallable');
        zoom.scaleBy(g, 1 / 1.1);
    });
}

function setChoosedTicket(hallPlace, sender, d3Sender, strokeWidth)
{
    d3Sender.style('fill', '#fff');
    d3Sender.style('stroke', '#' + hallPlace.BackColor);
    d3Sender.style('stroke-width', strokeWidth);
    //sender.attr('x', sender.attr('x') - (-1));
    //sender.attr('y', sender.attr('y') - (-1));
    sender.width(15);
    sender.height(15);

    updateChosenTicketsHeight();
}

function unsetChoosedTicket(hallPlace, sender, d3Sender)
{
    d3Sender.style('fill', '#' + hallPlace.BackColor);
    d3Sender.style('stroke', '#fff');
    d3Sender.style('stroke-width', '0');
    //sender.attr('x', sender.attr('x') - 1);
    //sender.attr('y', sender.attr('y') - 1);
    sender.width(15);
    sender.height(15);

    updateChosenTicketsHeight();
}

function fixX(x, factor, additional)
{
    /*if (isChrome()) {
        return x;
    }*/

    factor     = factor || 1;
    additional = additional || 0;

    return x + 2 * factor + additional;
}

function getSelectedTicketsCount()
{
    var ticketsAmount = 0;
    $('.hallPlace').each(function()
    {
        if (!$(this).data('checked')) {
            return;
        }
        ticketsAmount++;
    });

    return ticketsAmount;
}

function getSelectedTicketsSum()
{
    var ticketsSumValue = 0;
    $('.hallPlace').each(function()
    {
        if (!$(this).data('checked')) {
            return;
        }
        var currentPlace = php.hallPlacesMap[$(this).data('id')];
        ticketsSumValue  += parseInt(getDiscountPrice(currentPlace.Price));
    });
    return ticketsSumValue;
}

function recalculateSelectedTicketPrice()
{
    var ticketsAmount   = getSelectedTicketsCount();
    $('.ticketsAmount').text(ticketsAmount);
    $('.decl-places').text(app.declensionNoun(ticketsAmount, 'место', 'места', 'мест'));
    $('.decl-tickets').text(app.declensionNoun(ticketsAmount, 'билет', 'билета', 'билетов'));
    var ticketsSumm = getSelectedTicketsSum();
    $('.decl-summ').text(app.formatPriceRoubles(ticketsSumm));
    /*var ticketsSumValue = getSelectedTicketsSum();

    var service    = php.lectureDetails.paySystemMargin;
    var serviceSum = (ticketsSumValue * (service / 100)).toFixed(2);
    $('.ticketSumValue').text(ticketsSumValue);
    $('.serviceSumValue').text(serviceSum);
    $('.ticketsAmount').text(ticketsAmount);
    $('.allSumValue').text(parseFloat(ticketsSumValue) + parseFloat(serviceSum));*/
}

function isChrome()
{
    var isChromium = window.chrome,
        winNav = window.navigator,
        vendorName = winNav.vendor,
        isOpera = winNav.userAgent.indexOf("OPR") > -1,
        isIEedge = winNav.userAgent.indexOf("Edge") > -1,
        isIOSChrome = winNav.userAgent.match("CriOS");

    if (isIOSChrome) {
        return true;
    } else if (
        isChromium !== null &&
        typeof isChromium !== "undefined" &&
        vendorName === "Google Inc." &&
        isOpera === false &&
        isIEedge === false
    ) {
        return true;
    } else {
        return false;
    }
}

function mobileAndTabletcheck()
{
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

function isSelectedPlace(row, seat)
{
    for (var i in php.selectedPlaces) {
        if (row == php.selectedPlaces[i].row && seat == php.selectedPlaces[i].seat) {
            return true;
        }
    }

    return false;
}

function fillMemberInputs()
{
    var memberCollection = $('#memberRowsContainer .memberData');

    for (var i in php.membersData) {
        for (var inputName in php.membersData[i]) {
            if ('phoneCode' === inputName) {
                var mobileInput = memberCollection.eq(i).find('[name="mobile"]');
                var phoneCodeSelect = mobileInput.prev().find('select');
                setPhoneCodeSelectValue(phoneCodeSelect, php.membersData[i][inputName]);
                continue;
            }

            memberCollection.eq(i).find('[name="' + inputName + '"]').val(php.membersData[i][inputName]);
        }
    }
}

function showErrors(errors)
{
    var memberCollection = $('#memberRowsContainer .memberData');

    if (!undef(errors.members)) {
        for (var i in errors.members) {
            for (var inputName in errors.members[i]) {
                var errorInput = memberCollection.eq(i).find('[name="' + inputName + '"]');
                errorInput.addClass('ticket-data-error');
                errorInput.tooltip({
                    'title': errors.members[i][inputName][0]
                });
            }
        }
    }

    if (!undef(errors.delivery)) {
        var errorInput = $('#deliveryAddress');
        errorInput.addClass('ticket-data-error');
        errorInput.tooltip({
            'title': errors.delivery.address[0]
        });
    }

    if (!undef(errors.buyer)) {
        for (var i in errors.buyer) {
            for (var inputName in errors.buyer) {
                var errorInput = $('.signupBlock').find('[name="' + inputName + '"]');
                errorInput.addClass('ticket-data-error');
                errorInput.tooltip({
                    'title': errors.buyer[inputName][0]
                });
            }
        }
    }

    if (!undef(errors.orderDetails)) {
        for (var i in errors.orderDetails) {
            for (var inputName in errors.orderDetails) {
                var errorInput = $('[name="' + inputName + '"]');
                console.dir(errorInput);
                errorInput.addClass('ticket-data-error');
                errorInput.tooltip({
                    'title': errors.orderDetails[inputName][0]
                });
            }
        }
    }

    if (!undef(errors.offerAgreement)) {
        var errorInput = $('#offerAgreement');
        errorInput.addClass('ticket-data-error');

        var checkboxContainer = $('#offerAgreement').parent().parent();

        checkboxContainer.tooltip({
            'title': errors.offerAgreement[0]
        });

        checkboxContainer.addClass('errorAgreement');
    }
}

function collectMembers()
{
    var membersData = new Array();

    $('#memberRowsContainer .memberData').each(function() {
        var mobileInput = $(this).find('[name="mobile"]');
        var phoneCode = mobileInput.prev().find('select').val();

        membersData.push({
            'lastname' : $(this).find('[name="lastname"]').val(),
            'firstname': $(this).find('[name="firstname"]').val(),
            'mobile'   : mobileInput.val(),
            'phoneCode': phoneCode,
            'email'    : $(this).find('[name="email"]').val(),
            'age'      : $(this).find('[name="age"]').val()
        });
    });

    return membersData;
}

/**
 * Restores the places chosen before the login. The map is fresh by then: a place sold meanwhile is disabled on it
 * (price 0, the box office refuses it) and is not chosen again, nor is a place that is not on this map (KB-059).
 * The map keeps its flags in jQuery data, so they are read through jQuery.
 *
 * @returns {number} how many of the given places could not be chosen
 */
function setCheckedPlaces(checkedPlaces)
{
    const placesById = new Map();
    $('.hallPlace').each(function () {
        placesById.set($(this).data('id'), $(this));
    });

    let skipped = 0;
    checkedPlaces.forEach((value) => {
        const place = placesById.get(value.cell_id);

        if (place === undefined || place.data('disabled')) {
            skipped++;

            return;
        }

        selectPlace(place);
    });
    updateFriendPlaces();

    return skipped;
}

function getCheckedPlaces()
{
    var checkedPlaces = new Array();

    $('.hallPlace').each(function()
    {
        if (!$(this).data('checked')) {
            return;
        }
        var currentPlace = php.hallPlacesMap[$(this).data('id')];
        checkedPlaces.push({
            cell_id      : $(this).data('id'),
            row          : currentPlace.row,
            seat         : currentPlace.seat,
            PriceSell    : currentPlace.PriceSell,
            FreeOfferSeat: currentPlace.FreeOfferSeat,
            cod_sec      : currentPlace.cod_sec,
            name_sec     : currentPlace.name_sec
        });
    });

    return checkedPlaces;
}

function selectPlace(place)
{
    let currency = '';

    if (typeof php.currency !== 'undefined') {
        currency = php.currency;
    }

    place.data('checked', true);
    const currentPlace = php.hallPlacesMap[place.data('id')];
    let htmlToAdd = '<span class="choosed-ticket-span" data-id="' + place.data('id') + '">';
    htmlToAdd += '<span>' + app.formatPriceRoubles(parseInt(currentPlace.Price), currency) + '</span><br>'
    htmlToAdd += currentPlace.name_sec + '<br>'
    htmlToAdd += '<span>' + currentPlace.row + ' ряд, ' + currentPlace.seat + ' место </span><br>'
    $('.chosen-tickets-container').append(htmlToAdd);
    place.find('rect').css('fill', '#e50341');
    place.width(20);
    place.height(20);
}

function updateChosenTicketsHeight(remove)
{
    let maxHeight = 0;
    let tickets = $('.chosen-tickets-container > span');

    tickets.each((i, v) => {
        $(v).css('height', 'auto')
    });
    tickets.each((i, v) => {
        maxHeight = $(v).height() > maxHeight ? $(v).height() : maxHeight;
    });
    tickets.each((i, v) => {
       $(v).height(maxHeight);
    });
}

function reduceMemberRows(ticketsAmount)
{
    $('#memberRowsContainer .memberData').each(function(i) {
        if (ticketsAmount > i) {
            return;
        }
        $(this).remove();
    });
}

function addMemberRows(memberDataRowsCount, ticketsAmount)
{
    for (var i = 0; i < ticketsAmount - memberDataRowsCount; i++) {
        addMemberRow({
            'rowNumber': memberDataRowsCount + i + 1
        });
    }
}

function getSelector()
{
    if ('single' === php.lectureDetails.type) {
        return 'buyTicketTypeSingle';
    } else {
        return 'buyTicketTypeCourse';
    }
}

function addMemberRow(params)
{
    var rowTemplate = $('#memberDataTemplate').clone();

    rowTemplate.removeAttr('id');
    rowTemplate.find('.rowNumber').text(params.rowNumber);

    if (0 === $('#memberRowsContainer .memberData').size()) {
        rowTemplate.find('.removeMember').addClass('hidden');
    }

    var phoneCodeSelectorTemplate = $('#phoneCodeSelectorTemplate select').clone();
    phoneCodeSelectorTemplate.removeClass('hidden').addClass('custom-select');
    $(rowTemplate).find('[name="mobile"]').parent().prepend(phoneCodeSelectorTemplate);

    rowTemplate.appendTo('#memberRowsContainer');
    rowTemplate.find('[name="mobile"]').attr('id', 'memberRow' + params.rowNumber);
}

function updateFriendPlaces()
{
    var checkedPlaces = getCheckedPlaces();

    $('.event-info-aside__buy-ticket__member').each(function (i) {
        var place = checkedPlaces[i];

        var placeInfoStr = buyModule.renderMemberPlaceInfo(place);
        if (placeInfoStr) {
            $(this).find('.member-placeInfo-wrap').html($(placeInfoStr));
        }
    });
}

function toggleGiveTicketToFriendCheckbox()
{
    if (0 === getSelectedTicketsCount()) {
        $('.offline-ticket__form').find('.tickets-are-gift-checkbox').prop('checked', false);
    } else {
        $('.offline-ticket__form').find('.tickets-are-gift-checkbox').prop('checked', true);
    }
}

/*
function renderMembersRows(ticketsAmount)
{
    if (!$('#memberRowsContainer').size()) {
        return;
    }
    var memberDataRowsCount = $('#memberRowsContainer .memberData').size();

    if (memberDataRowsCount === ticketsAmount) {
        return;
    }

    if (memberDataRowsCount > ticketsAmount) {
        reduceMemberRows(ticketsAmount);
    } else {
        addMemberRows(memberDataRowsCount, ticketsAmount);
    }
}
*/

function getDiscountPrice(price)
{
    if (!php.promoCodeDiscount) {
        return price;
    }

    return price - price * php.promoCodeDiscount / 100;
}
